export default __webpack_public_path__ + "static/media/LastYearReferenceBadge.5b4522ca.png";